import {Component, ElementRef, EventEmitter, HostListener, Input, OnInit, Output, ViewChild} from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';

@Component({
    selector: 'app-component-default-select',
    templateUrl: './default-select.component.html',
    styleUrls: ['./default-select.component.scss'],
    animations: [
        trigger('fade', [
            state('in', style({opacity: 1, 'margin-top': '0px'})),
            transition(':enter', [style({opacity: 0, 'margin-top': '-15px'}), animate('0.1s ease-out')]),
            transition(':leave', animate('0.1s ease-out', style({opacity: 0, 'margin-top': '-15px'})))
        ])
    ]
})
export class DefaultSelectComponent implements OnInit {


    @Input('row') public row: DefaultSelectModel[];
    @Input('default_select') public default_select;
    @Input('disable') public disable;
    @Output('selectedVal') public selectedVal = new EventEmitter();
    public select_open = false;
    @ViewChild('select_label') public select_label: ElementRef;
    @ViewChild('select_body') public select_body: ElementRef;

    public selectedValue: any;

    constructor() {
    }

    @HostListener('document:click', ['$event'])
    AfterClick(event): void {
        if (this.select_open
            && this.select_label
            && !this.select_label.nativeElement.contains(event.target)
        ) {
            this.select_open = false;
        }
    }

    ngOnInit(): void {
        if (this.default_select && this.row) {
            for (const item of this.row) {
                if (item.id === this.default_select) {
                    this.select(item);
                }
            }
        }
    }

    select(item): void {
        this.selectedValue = item;
        this.selectedVal.emit(item.id);
    }
}

export class DefaultSelectModel {
    public id: any;
    public name: string;
}
